/**
 * Zustand store — selectedChildId for parent child-switcher.
 * parent role: stores the studentProfileId of the currently viewed child.
 * Persisted in localStorage so selection survives page reload.
 */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ChildSelectorState {
  selectedChildId: string | null;
  setSelectedChildId: (id: string | null) => void;
}

export const useChildSelector = create<ChildSelectorState>()(
  persist(
    (set) => ({
      selectedChildId: null,
      setSelectedChildId: (id) => set({ selectedChildId: id }),
    }),
    { name: 'clc-child-selector' },
  ),
);
